/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Written by `scripts/generate-file-type-accept.mjs` from
 * `backend/src/files/constants/file-types.constants.ts`, which is the authoritative table:
 * the backend validates every upload against it on `upload-complete`, so a frontend that
 * states something different only moves a refusal to the server.
 *
 * Regenerate with `pnpm generate:file-types` from the repo root. A stale copy fails a test
 * on both sides of the workspace — see the header of the generator for why it takes two.
 *
 * Read this through `lib/constants/file-type-accept.ts`, never directly: the frontend-owned
 * parts of the contract (the extension fallbacks, the display-only aliases, the client-intake
 * unwrap exception) live there and are not derivable from the table below.
 */

/** Every backend file type, and exactly the MIME types it validates against. */
export const FILE_TYPE_ACCEPTED_MIME_TYPES = {
  'aba-file': ['application/octet-stream'],

  'additional-document': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/heic',
    'image/heif'
  ],

  'ai-scribe-summary': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ],

  'ai-scribe-upload': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/heic',
    'image/heif'
  ],

  'client-intake-upload': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/heic',
    'image/heif'
  ],

  codicil: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],

  'correspondence-attachment': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ],

  'death-certificate': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png'
  ],

  'distribution-advice': ['application/pdf'],

  'distribution-declaration': [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ],

  'distribution-statement': [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword'
  ],

  'document-template': [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ],

  'email-template-attachment': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ],

  'grant-of-representation': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png'
  ],

  'handwritten-signature': ['image/jpeg', 'image/jpg', 'image/png'],

  'imported-correspondence': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'message/rfc822',
    'application/eml',
    'application/vnd.ms-outlook',
    'application/x-cfb',
    'application/octet-stream'
  ],

  'institution-form-signed': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png'
  ],

  'institution-form-template': ['application/pdf'],

  'instruction-sheet': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ],

  'intake-instruction-sheet': [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword'
  ],

  'law-firm-signed-document': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png'
  ],

  'lead-cost-agreement': [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword'
  ],

  'lead-document': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/heic',
    'image/heif'
  ],

  letterhead: ['application/pdf'],

  'matter-court-form-document': [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword'
  ],

  'matter-precedent-document': [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword'
  ],

  'planning-document': [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword'
  ],

  'primary-id': ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],

  'secondary-id': ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],

  'suggestion-attachment': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'video/mp4',
    'video/quicktime',
    'video/x-msvideo',
    'video/webm',
    'application/zip',
    'application/x-zip-compressed',
    'application/x-rar-compressed',
    'application/x-7z-compressed'
  ],

  'trust-account-statement': ['application/pdf'],

  'unknown-pending-ai-analysis': [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/plain'
  ],

  'vic-land-registry-deed': ['application/pdf'],

  will: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']
} as const satisfies Record<string, readonly string[]>;

/**
 * The file types whose `allowsEmailAttachmentExtraction` is set — a `.eml`/`.msg` is unwrapped
 * into its attachments by `FilesService.tryUnwrapEmailContainer` BEFORE MIME validation runs,
 * so these accept an email at the door without listing the email MIME types above.
 *
 * Not the whole story on the frontend: `client-intake-upload` unwraps too, through the portal
 * service rather than this flag. That exception is declared in `file-type-accept.ts`, where it
 * can carry its reason.
 */
export const EMAIL_UNWRAPPING_FILE_TYPE_SLUGS = [
  'additional-document',
  'distribution-declaration',
  'primary-id',
  'unknown-pending-ai-analysis'
] as const;

/**
 * The shapes a `.eml`/`.msg` actually arrives as, including the two the browser and the
 * magic-number sniffer disagree about. Backend `EMAIL_CONTAINER_MIME_TYPES`.
 */
export const EMAIL_CONTAINER_MIME_TYPES = [
  'message/rfc822',
  'application/eml',
  'application/vnd.ms-outlook',
  'application/x-cfb',
  'application/octet-stream'
] as const;
